import { render, staticRenderFns } from "./ExampleView.vue?vue&type=template&id=4bc280d0&scoped=true&"
import script from "./ExampleView.vue?vue&type=script&lang=js&"
export * from "./ExampleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc280d0",
  null
  
)

export default component.exports